import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import useScreen from 'hooks/useScreen';
import PDPAvailableInSizesSkeleton from './PDPAvailableInSizesSkeleton';
import PDPAvailableInSizesRow from './PDPAvailableInSizesRow';
import PDPAvailableInSizesListItem from './PDPAvailableInSizesRow/PDPAvailableInSizesListItem';
const AnimateHeight = loadable(() => import('react-animate-height'));
const MOBILE_AND_TABLET_DURATION = 300;
const DESKTOP_DURATION = 500;
const PDPAvailableInSizesUI = t0 => {
  const $ = _c(25);
  const {
    buildYourOwnDetails: t1,
    currentProductId,
    isExpanded: t2,
    loading,
    onToggleExpanded: t3,
    pdpIsModularBYOProduct: t4,
    products,
    productsDetails,
    showBYOSize: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const buildYourOwnDetails = t6;
  const isExpanded = t2 === undefined ? false : t2;
  const onToggleExpanded = t3 === undefined ? _temp : t3;
  const pdpIsModularBYOProduct = t4 === undefined ? false : t4;
  const showBYOSize = t5 === undefined ? false : t5;
  const {
    isMobileOrTablet
  } = useScreen();
  const duration = isMobileOrTablet ? MOBILE_AND_TABLET_DURATION : DESKTOP_DURATION;
  if (loading || !currentProductId || !products?.length) {
    let t7;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <PDPAvailableInSizesSkeleton />;
      $[2] = t7;
    } else {
      t7 = $[2];
    }
    return t7;
  }
  let t7;
  if ($[3] !== isExpanded || $[4] !== onToggleExpanded) {
    t7 = () => onToggleExpanded(!isExpanded);
    $[3] = isExpanded;
    $[4] = onToggleExpanded;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = !pdpIsModularBYOProduct ? `Available in ${products.length} sizes ${isExpanded ? "-" : "+"}` : `Also available in ${products.length} configurations ${isExpanded ? "-" : "+"}`;
  let t9;
  if ($[6] !== isExpanded || $[7] !== t7 || $[8] !== t8) {
    t9 = <button type="button" aria-expanded={isExpanded} className="inline-block text-sm font-bold text-brand cursor-pointer mt-1 md:mt-0 text-left" onClick={t7}>{t8}</button>;
    $[6] = isExpanded;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = isExpanded ? "auto" : 0;
  let t11;
  if ($[10] !== currentProductId || $[11] !== products || $[12] !== productsDetails) {
    t11 = [...products].sort(_temp2).map(t12 => {
      const {
        id
      } = t12;
      return <PDPAvailableInSizesRow detail={productsDetails?.[id]} isActive={id === currentProductId} key={id} pdpProductId={currentProductId} productsData={products} />;
    });
    $[10] = currentProductId;
    $[11] = products;
    $[12] = productsDetails;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== buildYourOwnDetails || $[15] !== showBYOSize) {
    t12 = showBYOSize ? <PDPAvailableInSizesListItem byoCollectionName={buildYourOwnDetails.name} dimensions={buildYourOwnDetails.dimensions || ""} id="byo" image="" isActive={false} isBYO={true} loading={false} name={`Build your own ${buildYourOwnDetails.name}`} price="" urlKey={buildYourOwnDetails.urlKey} /> : null;
    $[14] = buildYourOwnDetails;
    $[15] = showBYOSize;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== duration || $[18] !== t10 || $[19] !== t11 || $[20] !== t12) {
    t13 = <AnimateHeight duration={duration} height={t10}>{t11}{t12}</AnimateHeight>;
    $[17] = duration;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t9) {
    t14 = <div className="mb-3 md:mb-6">{t9}{t13}</div>;
    $[22] = t13;
    $[23] = t9;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};
PDPAvailableInSizesUI.propTypes = {
  buildYourOwnDetails: PropTypes.shape({
    dimensions: PropTypes.string,
    name: PropTypes.string,
    urlKey: PropTypes.string
  }),
  currentProductId: PropTypes.number,
  isExpanded: PropTypes.bool,
  loading: PropTypes.bool,
  onToggleExpanded: PropTypes.func,
  pdpIsModularBYOProduct: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    slug: PropTypes.string
  })),
  productsDetails: PropTypes.object,
  showBYOSize: PropTypes.bool
};
export default PDPAvailableInSizesUI;
function _temp() {}
function _temp2(a, b) {
  return a.id - b.id;
}